var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bcc-form-item",class:[
    {
      'is-error': _vm.validateState === 'error',
      'is-validating': _vm.validateState === 'validating',
      'is-success': _vm.validateState === 'success',
      'is-required': _vm.isRequired || _vm.required,
    },
  ]},[(_vm.label || _vm.$slots.label || !this.form.inline)?_c('label',{staticClass:"bcc-form-item__label",style:(_vm.labelStyle),attrs:{"for":_vm.labelFor}},[_c('span',{staticClass:"bcc-form-item__required-tag"},[_vm._v(_vm._s(_vm.isRequired ? "*" : ""))]),_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2):_vm._e(),_c('div',{staticClass:"bcc-form-item__content",style:(_vm.contentStyle)},[_vm._t("default"),_c('div',{staticClass:"bcc-form-item__error"},[_vm._v(" "+_vm._s(_vm.validateMessage)+" ")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }